import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ModalService } from './modal.service';


@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ModalComponent implements OnInit, OnDestroy {

  constructor(private modalService: ModalService, private el: ElementRef) {
    this.element = el.nativeElement;
  }
  @Input() id = '66';
  @Input() ariaBy = 'contentview';
  @Input() ariaLabelledBy: any;
  /** If there is data-binding on backdropClick (i.e. `[backdropClick]="logic()"`),
   * then when the user clicks on the backdrop of the modal, the modal will not
   * close. Instead it will fire an event back to the binded function (`login()`)
   */
  @Output() backdropClick = new EventEmitter<void>();
  private element: any;
  focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  modal: any;
  firstFocusableElement: any;
  focusableContent: any;
  lastFocusableElement: any;
  onClickOutside: boolean | undefined;

  ngOnInit(): void {
    // ensure id attribute exists
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }

    // moves element to bottom of page (just before </body>) so it can be displayed above everything else
    document.body.appendChild(this.element);

    // close modal on background click
    this.element.addEventListener('click', (e: any) => {
      // added change to prevent backdrop modal of covid form
      if (e.target.classList.contains('bsc-modal') && this.id !== 'formConfirmModal') {
        if (this.backdropClick.observers.length) {
          // if there is logic associated with clicking on backdrop
          this.backdropClick.emit();
        } else if (this.onClickOutside) {
          this.close();
        }
      }
    });

    // handle keyboad functionality
    this.element.addEventListener('keydown', (e: any) => {
      // close modal on esc
      if (e.keyCode === 27 || e.key === 'Escape') {
        this.close();
      }
      if (!(e.key === 'Tab' || e.keyCode === 0)) {
        return;
      }
      // if shift key pressed for shift + tab combination
      if (e.shiftKey) {
        if (e.target === this.firstFocusableElement) {
          // add focus for the last focusable element
          (this.lastFocusableElement).focus();
          e.preventDefault();
        }
        // if tab key is pressed
      } else {
        if (e.target === this.lastFocusableElement) {
          // if focused has reached to last focusable element then focus first focusable element after pressing tab
          // add focus for the first focusable element
          (this.firstFocusableElement).focus();
          e.preventDefault();
        }
      }

    });


    // add self (this modal instance) to the modal service so it's accessible from controllers
    this.modalService.add(this);
  }

  // remove self from modal service when component is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  // open modal
  open(onClickOutside?: boolean): void {
    this.element.style.display = 'block';
    this.modal = document.querySelector('#' + this.id);
    document.body.classList.add('bsc-modal-open');
    this.onClickOutside = onClickOutside;
    if(this.modal !== null){
    this.firstFocusableElement = this.modal.querySelectorAll(this.focusableElements)[0];
    this.focusableContent = this.modal.querySelectorAll(this.focusableElements);
    this.lastFocusableElement = this.focusableContent[this.focusableContent.length - 1];
    setTimeout(() => {
      (this.firstFocusableElement)?.focus();
    }, 100);
    }
  }

  // close modal
  close(): void {
    this.element.style.display = 'none';
    document.body.classList.remove('bsc-modal-open');
  }

}
